import React from 'react';
import { XAxis, YAxis, Label, Tooltip, BarChart, CartesianGrid, Bar } from 'recharts';

import { observer } from 'mobx-react-lite';

import sortBy from 'lodash/sortBy';
import takeRight from 'lodash/takeRight';
import ObservableAutoSizer from '@vromo/ui/components/ObservableAutoSizer';
import { Job, Site } from 'models';

interface Props {
    jobs: Job[];
    sites: Site[];
}
export default observer<Props>(function JobsBySiteChart({ jobs, sites }) {
    const groupBySite = () => {
        const siteData = sites.map((s) => {
            return { site: s, jobsDone: 0 };
        });

        jobs.filter((j) => j.site != null).forEach((j) => {
            const siteId = j.site!.id;

            siteData.forEach((sd) => {
                if (sd.site.id == siteId) {
                    sd.jobsDone++;
                }
            });
        });

        return siteData.map((sd) => {
            return {
                siteName: sd.site.contact!.name,
                jobsDone: sd.jobsDone
            };
        });
    };

    const siteNameFormatter = (site: string) => {
        if (site.length > 40) {
            return `${site.slice(0, 37)}...`;
        } else {
            return site;
        }
    };

    const siteData = takeRight(
        sortBy(groupBySite(), (j) => j.jobsDone),
        8
    )
        .reverse()
        .filter((s) => s.jobsDone > 0);

    if (siteData.length === 0) {
        return (
            <div
                style={{
                    display: 'flex',
                    height: '80%',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                No jobs completed for any sites.
            </div>
        );
    }

    return (
        <ObservableAutoSizer customChildren={({ width }: { width: number }) => (
            <BarChart
                width={width}
                height={250}
                data={siteData}
                layout="vertical"
                margin={{ top: 0, right: 30, left: 0, bottom: 50 }}>
                <CartesianGrid strokeDasharray={'3 3'} />
                <YAxis
                    dataKey="siteName"
                    tickFormatter={(t) => siteNameFormatter(t)}
                    type="category"
                    width={250}
                />
                <XAxis type="number">
                    <Label
                        value={'Jobs Completed'}
                        position={'bottom'}
                        offset={0}
                        style={{ textAnchor: 'middle', fontSize: '12px' }}
                    />
                </XAxis>
                <Tooltip />
                <Bar
                    dataKey="jobsDone"
                    formatter={(value: number) => [value, 'Jobs Completed']}
                    stroke="#59CD90"
                    fill="#59CD90"
                />
            </BarChart>
        )} />
    );
});
